// ===================================================================
// 📦 ARQUIVO DE ÍNDICE PRINCIPAL — Ingressa
// ===================================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { migrateIngressaBrowserStorage } from './utils/ingressaBrand';
import { preparePwaForAuthDeepLink, registerCandidatePwa } from './pwa/registerCandidatePwa';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/candidateMobile.css';

migrateIngressaBrowserStorage();
preparePwaForAuthDeepLink();
registerCandidatePwa();

// Adicionar estilos CSS globais
const style = document.createElement('style');
style.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes modalIn {
    from { opacity: 0; transform: scale(0.96); }
    to { opacity: 1; transform: scale(1); }
  }
  
  * {
    box-sizing: border-box;
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  
  button:hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }
  
  button:active {
    transform: translateY(0);
  }
  
  button:focus-visible {
    outline: 2px solid #3B82F6;
    outline-offset: 2px;
  }
  
  input:focus, select:focus, textarea:focus {
    border-color: #3B82F6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
    outline: none;
  }
  
  /* Remover spinners dos campos de número */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input[type="number"] {
    -moz-appearance: textfield;
  }
  
  button[aria-label="Fechar modal"]:hover,
  button[aria-label="Fechar"]:hover {
    background: rgba(0,0,0,0.12) !important;
  }
  
  tbody tr:hover {
    background-color: #F9FAFB;
  }
  
  nav [aria-current="page"] {
    pointer-events: none;
  }
  
  nav button:not([aria-current="page"]):hover {
    background-color: #F3F4F6;
    color: #374151;
  }
  
  [data-modal-content] {
    animation: modalIn 0.2s ease-out;
  }
  
  /* Remover marcadores de lista nos selos de status do candidato */
  [data-status-timeline],
  [data-status-timeline] * {
    list-style: none !important;
    list-style-type: none !important;
    counter-reset: none !important;
  }
  
  .report-candidates-contact-table th,
  .report-candidates-contact-table td {
    vertical-align: top;
  }
  .report-candidates-contact-table .contact-cell-nowrap {
    white-space: nowrap;
  }
  
  @media print {
    @page {
      size: A4;
      margin: 15mm;
    }
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .no-print {
      display: none !important;
    }
    .hide-on-print {
      display: none !important;
    }
    .report-content {
      box-shadow: none !important;
      padding: 0 12px !important;
      max-width: 100% !important;
      width: 100% !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
    }
    .report-content.report-waiting-list {
      overflow-x: auto !important;
      overflow-y: visible !important;
    }
    .report-content.report-candidates-contact {
      overflow-x: visible !important;
      overflow-y: visible !important;
    }
    .report-waiting-list-scroll {
      overflow-x: auto !important;
    }
    .report-candidates-contact-scroll {
      overflow-x: visible !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    .report-waiting-list-table {
      table-layout: auto !important;
      width: max-content !important;
      min-width: 100% !important;
      max-width: none !important;
    }
    .report-waiting-list-table th,
    .report-waiting-list-table td,
    .report-candidates-contact-table th,
    .report-candidates-contact-table td {
      vertical-align: top !important;
    }
    .report-candidates-contact-table {
      table-layout: fixed !important;
      width: 100% !important;
      max-width: 100% !important;
      font-size: 7px !important;
    }
    .report-candidates-contact-table th,
    .report-candidates-contact-table td {
      padding: 2px 3px !important;
      overflow-wrap: anywhere !important;
      word-break: break-word !important;
      white-space: normal !important;
    }
    .report-candidates-contact-table .contact-cell-nowrap {
      white-space: nowrap !important;
    }
    .report-candidates-contact-table thead {
      display: table-header-group;
    }
    .report-enrollment-table {
      font-size: 10px !important;
      width: 100% !important;
      table-layout: fixed !important;
    }
    .report-enrollment-table th,
    .report-enrollment-table td {
      padding: 4px 6px !important;
    }
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
); 